<template>
  <el-popover
    placement="top"
    :width="width"
    trigger="hover"
    :content="content"
    popper-class="sr-popover"
  >
    <template slot="reference">
      <slot></slot>
    </template>
  </el-popover>
</template>

<!--
  功能：功能描述
  汪振涛
  时间：2021年06月08日 10:24:25
  版本：v1.0
-->
<script>
export default {
  components: {},
  props: {
    content: {
      type: [String, Number],
      default() {
        return "内容";
      },
    },
    width: {
      type: [String, Number],
      default() {
        return "auto";
      },
    },
  },
  name: "SrPopover",
  data() {
    return {};
  },
};
</script>




// WEBPACK FOOTER //
// packages/SrPopover/SrPopover.vue